import script from "./TranslationEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationEditor.vue?vue&type=script&setup=true&lang=js"

import "./TranslationEditor.vue?vue&type=style&index=0&id=49dd7942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dd7942"]])

export default __exports__